import React from 'react';

const About = () => {
  return (
    <section className='section about-section'>
      <h1 className='section-title'>about us</h1>
      <p>
        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores
        voluptate reiciendis asperiores, veniam nihil eligendi reprehenderit et
        culpa tenetur quibusdam itaque suscipit, quisquam pariatur ad natus nam
        saepe ullam aperiam quae! Dicta veniam magnam tempora quo pariatur
        ducimus vitae accusamus.
      </p>
    </section>
  );
};

export default About;
